import MonixModal from "@/global/components/monix-modal";
import { Spin } from "antd";
import { useEffect, useState } from "react";
import { ReactComponent as CheckSvg } from '@/global/icons/table/check.svg';
import { ReactComponent as CheckedSvg } from '@/global/icons/table/checked.svg';
import { useParams } from "react-router-dom";
import TnMessage from "@/global/components/message";
import { GlobalSensor } from "@/global/interface/lib-device/global-sensor";
import { getGlobalSensors } from "@/api/lib/lib-sensor";

interface IProps {
    sensorType: number
    visible: boolean
    setVisible: (value: boolean) => void
    onFinish: (values: number[]) => void
    loading: boolean
    filterItems: GlobalSensor[]
}

export default function LinkGlobalSensorModal(props: IProps) {
    const { projectId } = useParams();
    const [globalDataBoxes, setGlobalSensores] = useState<GlobalSensor[]>([]); // 可选中的传感器
    const [selected, setSelected] = useState<number[]>([]); // 选中的传感器id

    // 初始化
    useEffect(() => {
        generateData();
    }, [])

    // 按下确认按钮
    const onSaveClick = () => {
        if (selected?.length === 0) {
            props.setVisible(false);
            return;
        }
        if (props?.onFinish) {
            props.onFinish(selected);
        }
    }

    // 获取可选择数据
    const generateData = () => {
        getGlobalSensors({ type: props.sensorType }).then(res => {
            let data: GlobalSensor[] = res.data || [];
            if(props?.filterItems) {
                data = data?.filter(item => !props?.filterItems?.some(i => i.id === item.id)) || [];
            }
            setGlobalSensores(data);
        })
    }

    return (
        <MonixModal
            title={"添加传感器"}
            visible={props.visible}
            setVisible={(e) => props.setVisible(e)}
            onSaveClick={onSaveClick}
            wrapClassName="link-global-device-modal"
            saveDisable={props.loading}
        >
            <Spin wrapperClassName="link-global-device-body" spinning={props.loading}>
                <div className="link-body">
                    {globalDataBoxes?.length !== 0 && globalDataBoxes?.map((item, key) => (
                        <div className="link-item" key={key}>
                            <div className="item-icon" onClick={() => {
                                let idx = selected?.findIndex(g => g === item.id);
                                setSelected(prev => {
                                    if (idx === -1) {
                                        prev.push(item.id);
                                    } else {
                                        prev.splice(idx, 1);
                                    }
                                    return [...prev];
                                })
                            }}>
                                {!selected?.some(g => g === item.id) && <CheckSvg />}
                                {selected?.some(g => g === item.id) && <CheckedSvg />}
                            </div>
                            <div className="item-text">{`名称：${item?.name || ''}`}</div>
                            <div className="item-text">{`型号：${item?.marking || ''}`}</div>
                            <div className="item-text">{`厂商：${item?.manufacturer || ''}`}</div>
                        </div>
                    ))}
                    {globalDataBoxes?.length === 0 && <div className="link-item">
                        <div className="item-text">{`暂无数据`}</div>
                    </div>
                    }
                </div>
            </Spin>
        </MonixModal>
    )
}